"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShellProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const clubTabChangeEvent_1 = __importDefault(require("./clubTabChangeEvent"));
const shellContext_1 = require("./shellContext");
const ShellProvider = ({ children, history, match, isMembership = true, basename, slug, locale, user, productId, isAttendant }) => {
    return ((0, jsx_runtime_1.jsx)(shellContext_1.ShellContext.Provider, { value: {
            isMembership,
            dispatchMembershipTabChange: clubTabChangeEvent_1.default.dispatch,
            history,
            match,
            slug,
            basename,
            productId,
            locale,
            user,
            isAttendant
        }, children: children }));
};
exports.ShellProvider = ShellProvider;
